import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=b8d4c9ee"
import script from "./Candidates.vue?vue&type=script&lang=js"
export * from "./Candidates.vue?vue&type=script&lang=js"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=b8d4c9ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports